import React from 'react';

import { BaseIconProps } from '.';

export const Diameter = ({ fill }: BaseIconProps) => {
  return (
    <path
      fill={fill}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M548.441 94.5C436.499 94.5 329.142 139.303 249.987 219.053C170.832 298.803 126.364 406.967 126.364 519.75C126.364 621.11 162.28 718.739 227.013 795.365L840.038 212.299C761.598 136.778 657.183 94.5 548.441 94.5ZM908.316 147.357C812.065 52.9356 682.962 0 548.441 0C411.623 0 280.409 54.7592 183.664 152.231C86.9192 249.703 32.5685 381.904 32.5685 519.75C32.5685 645.269 77.6329 766.107 158.734 860.306L0 1011.28L64.3871 1080L226.467 925.841C317.443 999.066 430.873 1039.5 548.441 1039.5C685.259 1039.5 816.474 984.741 913.219 887.269C1009.96 789.797 1064.31 657.596 1064.31 519.75C1064.31 411.386 1030.73 306.512 969.359 219.255L1080 114.021L1015.61 45.3039L908.316 147.357ZM900.326 284.914L295.499 860.182C368.074 914.92 456.718 945 548.441 945C660.383 945 767.74 900.197 846.895 820.447C926.05 740.698 970.519 632.534 970.519 519.75C970.519 435.607 945.767 354.034 900.326 284.914Z"
    />
  );
};
